export default ["sm", "md", "lg", "xl"];
